import acceptanceDocuments from './acceptanceDocuments';
import accounts from './accounts';
import categories from './categories';
import composer from './composer';
import emailTemplates from './emailTemplates';
import evaluations from './evaluations';
import images from './images';
import invoices from './invoices';
import menu from './menu';
import messages from './messages';
import modelViewers from './modelViewers';
import pages from './pages';
import permissions from './permissions';
import products from './products';
import profiles from './profiles';
import projects from './projects';
import projectMemberInvites from './projectMemberInvites';
import results from './results';
import sourceFiles from './sourceFiles';
import statuses from './statuses';
import surveys from './surveys';
import tags from './tags';
import tasks from './tasks';
import transactionTags from './transactionTags';
import twinAssets from './twinAssets';
import twinMaterials from './twinMaterials';
import twinParts from './twinParts';
import twins from './twins';
import twinRules from './twinRules';
import twinPublish from './twinPublish';
import teams from './teams';
import users from './users';
import taskMemberInvites from './taskMemberInvites';
import whiteboards from './whiteboards';

const models = {
  acceptanceDocuments,
  accounts,
  categories,
  composer,
  emailTemplates,
  evaluations,
  images,
  invoices,
  menu,
  messages,
  modelViewers,
  pages,
  permissions,
  products,
  profiles,
  projects,
  projectMemberInvites,
  results,
  sourceFiles,
  statuses,
  surveys,
  tags,
  taskMemberInvites,
  tasks,
  teams,
  transactionTags,
  twinAssets,
  twinMaterials,
  twinParts,
  twins,
  twinRules,
  twinPublish,
  users,
  whiteboards
};

export default models;
